import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import ContenidoOpcionesComponent from "./contenido_opciones.component";
/* import ContenidoMapaOlComponent from "./contenido_mapa_ol.component"; */
import ContenidoMapaComponent from "./contenido_mapa.component";
import CityComponent from "./city.component";
import ModalComponent from "./modal.component";
import dolty from "../../assets/icon_mapa/doty-dealer-of-the-year-2025.webp";

/*eslint-disable */

interface ContenidoComponentProps {
  concesionarios: any;
}

declare const window: any;
const ContenidoComponent: React.FC<ContenidoComponentProps> = ({
  concesionarios,
}) => {
  const [ciudad, setCiudad] = useState("todo");
  const [vitrina, setVitrina] = useState("ventas/taller");
  const [vehiculo, setVehiculo] = useState("todo");
  const [palabra, setPalabra] = useState("");
  const [selectedConcesionarios, setSelectedConcesionarios] = useState([]);
  const [mylocation, setMylocation] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState(null);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);
  
  const activeCity = ciudad === "todo" || ciudad === "Colombia" ? "Colombia" : ciudad;
  const pageTitle = activeCity === "Colombia"
    ? "Concesionarios Hyundai Colombia | Direcciones, Teléfonos y Horarios"
    : `Concesionario Hyundai ${activeCity} | Horarios y Dirección`;

  const pageDescription = activeCity === "Colombia"
    ? "Encuentra tu concesionario o taller autorizado Hyundai más cercano en Colombia. Consulta direcciones, horarios de atención, teléfonos y ubicaciones."
    : `Visita el concesionario y taller autorizado Hyundai en ${activeCity}. Direcciones, teléfonos, horarios de atención y mapas para agendar tu servicio o cotizar.`;

  const originUrl = window.location.origin;

  // Construir estructurado dinámico para los concesionarios mostrados
  const dealerSchemas = selectedConcesionarios.slice(0, 10).map((dealer: any) => ({
    "@context": "https://schema.org",
    "@type": dealer.is_sales_room ? "AutoDealer" : "AutoRepair",
    "name": dealer.name,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": dealer.address,
      "addressLocality": dealer.city,
      "addressCountry": "CO"
    },
    "telephone": dealer.phone1 || dealer.phone2 || undefined,
    "geo": dealer.latitude && dealer.longitude ? {
      "@type": "GeoCoordinates",
      "latitude": parseFloat(dealer.latitude),
      "longitude": parseFloat(dealer.longitude)
    } : undefined,
    "url": dealer.url_googlemaps || originUrl
  }));

  const breadcrumbsList = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Inicio",
      "item": originUrl
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Concesionarios",
      "item": `${originUrl}/concesionarios`
    }
  ];

  if (activeCity !== "Colombia") {
    breadcrumbsList.push({
      "@type": "ListItem",
      "position": 3,
      "name": activeCity,
      "item": `${originUrl}/concesionarios?ciudad=${encodeURIComponent(activeCity)}`
    });
  }

  return (
    <div className="contenido-concesionarios-component">
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                "itemListElement": breadcrumbsList
              },
              ...dealerSchemas
            ]
          })}
        </script>
      </Helmet>
      <ContenidoOpcionesComponent
        ciudad={ciudad}
        setCiudad={setCiudad}
        vitrina={vitrina}
        setVitrina={setVitrina}
        vehiculo={vehiculo}
        setVehiculo={setVehiculo}
        concesionarios={concesionarios}
        selectedConcesionarios={selectedConcesionarios}
        setSelectedConcesionarios={setSelectedConcesionarios}
        setPalabra={setPalabra}
        palabra={palabra}
        setMylocation={setMylocation}
        mylocation={mylocation}
        handleOpenModal={handleOpenModal}
        selectedDealer={selectedDealer}
        onSelectDealer={setSelectedDealer}
      />
      
      <ContenidoMapaComponent
        ciudad={ciudad}
        selectedConcesionarios={selectedConcesionarios}
        mylocation={mylocation}
        setCiudad={setCiudad}
        selectedDealer={selectedDealer}
        onSelectDealer={setSelectedDealer}
      />
      
      <CityComponent setCiudad={setCiudad} />
      {/* <ContenidoMapaOlComponent /> */}
      
      <ModalComponent isOpen={isModalOpen} onClose={handleCloseModal}>
        <div className="dolty-modal-container">
          <div className="img-dolty-modal-container">
            <img src={dolty} alt="Dealer of the Year 2025 - Hyundai" />
          </div>
          <div className="txt-dolty-modal-container">
            {/* H2 - Título del modal */}
            <h2 className="title-txt-dolty-modal-container">Hyundai DOTY</h2>
            
            {/* H3 - Descripción del modal */}
            <h3 className="description-txt-dolty-modal-container">
              Este concesionario ha sido seleccionado como uno de los "100
              mejores concesionarios del mundo" por sus excelentes resultados en
              ventas, servicio al cliente e instalaciones.
            </h3>
          </div>
        </div>
      </ModalComponent>
    </div>
  );
};

export default ContenidoComponent;